<!--
tabela GRUTRIB, REGRAIMP, GRUTRIBNCM

cg/grutrib/
cg/grutrib/:id

BO_CG.POST_GRUTRIB
BO_CG.DELETE_GRUTRIB













FORM CHAMADO PELO FORM DE ITEM DE PEDIDO

/regraimp/:ufori/:finalidade/:ncm





 -->

<template>
  <div class="nb-modal-scrollable">
    <div class="container nb-modal-scrollable-container">
      <div class="nb-modal-header">
        <h4 class="def-title">Incluir Regras de Imposto</h4>
        <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="nb-modal-scrollable-body">
        <div>
          <div class="row" v-if="grutrib">
            <div class="col-md-2 col-3">
              <v-label :metadata-field="metadata.grutrib.codgrutrib"></v-label><br>
              <span class="lbl">{{ grutrib.codgrutrib }}</span>
            </div>
            <div class="col-md-6 col-9">
              <v-label :metadata-field="metadata.grutrib.descricao"></v-label><br>
              <span class="lbl">{{ grutrib.descricao }}</span>
            </div>
          </div>
          <br>
          <label-title title="Selecione o Estado ou Região de Destino" class="nb-margin-bottom"></label-title>

          <div class="row">
            <form-field ref="ufdest" v-model="ufdest" type="select" col="3" :select-options="estadoList"
              :metadata="metadata.regraimp.ufdest"></form-field>
            <span v-if="!ufdest" class="nb-dica" style="">As regras de impostos são definidas para o estado de destino e
              por tipo de cliente</span>
          </div>
          <div class="row" v-if="ufdest">
            <form-field v-model="optsimples" type="select" col="2" :metadata="metadata.regraimp.optsimples">
            </form-field>
          </div>
          <div class="row" v-if="ufdest">
            <form-field v-model="codgrucli" type="select2" col="3" :metadata="metadata.regraimp.codgrucli"
              :select2="{ entity: 'grucli', minlength: 0 }"></form-field>
          </div>

          <div>
            <div class="mainbox" v-for="(regraimp, index) in regraimpList" v-bind:key="index"
              style="background-color: #eee">

              <div class="box">
                <label-title v-if="regraimp.finalidade == 'I'" title="Industrialização"></label-title>
                <label-title v-if="regraimp.finalidade == 'R'" title="Revenda"></label-title>
                <label-title v-if="regraimp.finalidade == 'F'" title="Consumo Final"></label-title>
                <!-- <label-title title="Nova Regra"></label-title><br> -->
                <div class="col" v-if="regraimp.validate">
                  <div class="alert alert-warning fade show" role="alert">
                    <span> <strong>Erro de validação:</strong> {{ regraimp.validate }} </span>
                  </div>
                  <!-- <small class="error"> {{ regraimp.validate }} </small> -->
                </div>
                <!-- <div class="row">
                                    <div class="col-md-2">
                                        <v-button icon="fa-trash" @click="handleExcluiRegra(index)"></v-button>
                                    </div>
                                </div> -->
                <br>
                <div v-if="grutrib.regra_geral != 'S'" class="row">
                  <form-field v-model="regraimp.aicminterno" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.aicminterno" :precision="2" name="aicminterno" :v-errors="errors"
                    v-validate="metadata.regraimp.aicminterno.validator"></form-field>
                  <form-field v-model="regraimp.aicmexterno" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.aicmexterno" :precision="2" name="aicmexterno" :v-errors="errors"
                    v-validate="metadata.regraimp.aicmexterno.validator"></form-field>
                  <form-field v-model="regraimp.ricm" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.ricm" :precision="2" name="ricm" :v-errors="errors"
                    v-validate="metadata.regraimp.ricm.validator"></form-field>
                  <form-field v-model="regraimp.mva" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.mva" :precision="2" name="mva" :v-errors="errors"
                    v-validate="metadata.regraimp.mva.validator"></form-field>
                  <form-field v-model="regraimp.mvaorig" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.mvaorig" :precision="2" name="mvaorig" :v-errors="errors"
                    v-validate="metadata.regraimp.mvaorig.validator"></form-field>
                  <form-field v-model="regraimp.aicmst" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.aicmst" :precision="2" name="aicmst" :v-errors="errors"
                    v-validate="metadata.regraimp.aicmst.validator"></form-field>
                  <form-field v-model="regraimp.pautaicmst" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.pautaicmst" :precision="2" name="pautaicmst" :v-errors="errors"
                    v-validate="metadata.regraimp.pautaicmst.validator"></form-field>
                  <form-field v-model="regraimp.ricmst" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.ricmst" :precision="2" name="ricmst" :v-errors="errors"
                    v-validate="metadata.regraimp.ricmst.validator"></form-field>
                  <form-field v-model="regraimp.afcpst" type="value" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.afcpst" :precision="2" name="afcpst" :v-errors="errors"
                    v-validate="metadata.regraimp.afcpst.validator"></form-field>
                  <!-- <div class="col-6 col-md-6 mt-3">
                                        <input-checkbox v-model="regraimp.bcdifalnovo" value-checked="S" value-unchecked="N" :label="metadata.regraimp.bcdifalnovo.label" :title="metadata.regraimp.bcdifalnovo.help" :disabled="regraimp.stregraimp=='I'"></input-checkbox>
                                    </div> -->
                  <form-field v-model="regraimp.cfop" type="select2" col="6" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.cfop" :select2="{ entity: 'cfop/saidas', minlength: 0 }"></form-field>

                  <form-field v-model="regraimp.sticm" type="select2" col="6" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.sticm" :select2="{ entity: 'tabpadval/11', minlength: 0 }">
                  </form-field>

                  <form-field v-model="regraimp.csosn" type="select2" col="6" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.csosn" :select2="{ entity: 'tabpadval/7', minlength: 0 }"></form-field>

                  <form-field v-model="regraimp.bcdifalnovo" type="select" col="3"
                    :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.bcdifalnovo"></form-field>
                  <form-field v-model="regraimp.optsimples" type="select" col="2" :disabled="regraimp.stregraimp == 'I'"
                    :metadata="metadata.regraimp.optsimples"></form-field>
                  <form-field v-model="regraimp.dtinicio" type="date" col="2" :metadata="metadata.regraimp.dtinicio"
                    name="dtinicio" :v-errors="errors" v-validate="metadata.regraimp.dtinicio.validator"></form-field>
                  <form-field v-model="regraimp.dtfim" type="date" col="2" :metadata="metadata.regraimp.dtfim"
                    name="dtfim" :v-errors="errors" v-validate="metadata.regraimp.dtfim.validator"></form-field>
                </div>
                <div v-if="grutrib.regra_geral == 'S'" class="row">
                  <form-field v-model="regraimp.tipo_calc_difal" type="select" col="3"
                    :disabled="regraimp.stregraimp == 'I'" :metadata="metadata.regraimp.tipo_calc_difal"></form-field>
                  <form-field v-model="regraimp.dtinicio" type="date" col="2" :metadata="metadata.regraimp.dtinicio"
                    name="dtinicio" :v-errors="errors" v-validate="metadata.regraimp.dtinicio.validator"></form-field>
                  <form-field v-model="regraimp.dtfim" type="date" col="2" :metadata="metadata.regraimp.dtfim"
                    name="dtfim" :v-errors="errors" v-validate="metadata.regraimp.dtfim.validator"></form-field>
                </div>
              </div>
            </div>
            <!-- DESABILITADO O BOTAO DE ADICIONAR REGRAS
                            <div class="row">
                            <div class="col-md-12 col-12">
                                <v-button label="Adicionar Nova Regra Na Lista" title="" icon="fa-plus" :nb-btdef="true" @click="handleAdicionaRegra"></v-button>
                            </div>
                        </div> -->
          </div> <!-- lista de regras -->

        </div>

        <div class="nb-modal-scrollable-footer">
          <v-button ref="btnConfirm" label="Salvar" title="" :nb-btdef="true" @click="handleSave"></v-button>
          <v-button ref="btnClose" label="Cancelar" title="" @click="handleCloseForm"></v-button>
        </div>

        <vue-snotify></vue-snotify>

        <md-message v-if="showMessage" :code="codeMessage" @close="closeMessage()" @confirm="handleConfirmMessage()">
        </md-message>
      </div>
    </div>
  </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
  props: {
    grutrib: {},
  },

  data() {
    return {
      crudText: '',
      crud: 'ins',

      metadata: this.$store.getters.getEntities.metadata,
      regraimp: { ...this.$store.getters.getEntities.regraimp },
      regraimpList: [],  //array de regras de impostos (tabela regraimp)

      estadoList: [],

      showMessage: false,
      message: '',
      ufdest: '',
      codgrucli: null,
      optsimples: 'S',

      tabs: ['Industrialização', 'Revenda', 'Consumo Final'], //paginas
      activeTab: 0 //pagina ativa

    }
  },

  computed: {

    regraimpInd: function () {
      return this.regraimpList.filter(function (obj) {
        return obj.finalidade == 'I'
      })
    },

    regraimpRev: function () {
      return this.regraimpList.filter(function (obj) {
        return obj.finalidade == 'R'
      })
    },

    regraimpFinal: function () {
      return this.regraimpList.filter(function (obj) {
        return obj.finalidade == 'F'
      })
    }
  },

  watch: {
    ufdest: function () {
      //atualiza o campo uf de destino nas regras
      if (this.regraimpList.length == 0) {
        this.handleAdicionaRegra('I')
        this.handleAdicionaRegra('R')
        this.handleAdicionaRegra('F')
      }
      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].ufdest = this.ufdest
      }
    },
    codgrucli: function () {
      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].codgrucli = this.codgrucli
      }
    },
    optsimples: function () {
      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].optsimples = this.optsimples
      }
    }
  },

  methods: {
    closeForm() {
      this.$emit('closeform')
    },

    handleCloseForm() {
      this.closeForm()
    },

    handleSave() {
      //botao salvar

      //valida se existe duplicidade de regras e depois valida o preenchimento dos campos
      if (!this.regraCheckDuplicate()) {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
            this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
          } else {
            this.apiPost()
          }
        })
      }
    },

    configuraRegrasRegiao() {
      //EFETUA A CRIACAO DE NOVA LISTA REGRAS PARA SER ENVIADA AO SERVIDOR QUANDO USUARIO SELECIONAR UMA REGIAO
      //PARA CRIACAO DAS REGRAS DE IMPOSTOS

      for (var x = 0; x < this.regraimpList.length; x++) {
        this.regraimpList[x].ufdest = this.ufdest   //atualiza uf caso tenha sido alterado apos definicao
        this.regraimpList[x].optsimples = this.optsimples
        this.regraimpList[x].codgrucli = this.codgrucli
      }

      if (this.ufdest != '1' && this.ufdest != '2' && this.ufdest != '3' && this.ufdest != '4' && this.ufdest != '5') {
        return this.regraimpList
      }

      let regras = []
      let uf = []
      let ufsul = ['RS', 'SC', 'PR']
      let ufsudeste = ['SP', 'ES', 'RJ', 'MG']
      let ufnorte = ['AM', 'AC', 'RR', 'RO', 'PA', 'TO']
      let ufcentro = ['MT', 'MS', 'GO', 'DS']
      let ufnordeste = ['AL', 'BA', 'CE', 'MA', 'RN', 'PB', 'PE', 'SE']

      if (this.ufdest == '1') {
        uf = ufsul
      } else if (this.ufdest == '2') {
        uf = ufsudeste
      } else if (this.ufdest == '5') {
        uf = ufcentro
      } else if (this.ufdest == '4') {
        uf = ufnordeste
      } else if (this.ufnorte == '3') {
        uf = ufnorte
      }

      for (var x = 0; x < this.regraimpList.length; x++) {
        for (var i = 0; i < uf.length; i++) {
          this.regraimp = { ...this.regraimpList[x] }
          this.regraimp.ufdest = uf[i]
          regras.push(this.regraimp)
        }
      }

      return regras

    },

    changeTab(idx) {
      //mudança de pagina
      this.activeTab = idx
    },

    handleExcluiRegra(index) {
      //exclui uma regra
      this.regraimpList.splice(index, 1)
    },

    handleAdicionaRegra(finalidade) {
      //adiciona nova linha na lsita de regras
      if (this.ufdest === '') {
        this.$erpToastError('Selecione um Estado antes de incluir nova regra')
        return
      }
      let regra = { ...this.$store.getters.getEntities.regraimp }
      regra.optsimples = 'S'
      regra.bcdifalnovo = 'S'
      regra.stregraimp = 'A'
      if (finalidade) {
        regra.finalidade = finalidade
      } else {
        if (this.activeTab == 0) {
          regra.finalidade = 'I'
        } else if (this.activeTab == 1) {
          regra.finalidade = 'R'
        } else if (this.activeTab == 2) {
          regra.finalidade = 'F'
        }
      }
      regra.ufdest = this.ufdest //UF selecionada
      this.regraimpList.push(regra)

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async loadEstados() {
      //carrega lista de estados cadastrados
      await this.$store.dispatch('loadEstadoRegras')
      if (this.$store.getters.getEstadoList) {
        this.estadoList = this.$store.getters.getEstadoList.map(function (obj) {
          return { id: obj.uf, text: obj.uf }
        })
      }

      let regiao = { id: '1', text: 'SUL' }
      this.estadoList.push(regiao)
      regiao = { id: '2', text: 'SUDESTE' }
      this.estadoList.push(regiao)
      regiao = { id: '3', text: 'NORTE' }
      this.estadoList.push(regiao)
      regiao = { id: '4', text: 'NORDESTE' }
      this.estadoList.push(regiao)
      regiao = { id: '5', text: 'CENTRO' }
      this.estadoList.push(regiao)

      this.regraimpList = []
    },

    regraCheckDuplicate() {
      //checa se foi digitado alguma regra duplicado para o grupo de tributacao, pesquisando no array regraList
      //considerando como chave os campos UFDEST, FINALIDADE, ORIMERC, CODGRUCLI

      let test = {}
      //cria novo objeto array para fazer a veiricacao de duplicidades
      let arrRegra = this.regraimpList.map(function (obj) {
        return { ufdest: obj.ufdest, finalidade: obj.finalidade, orimerc: obj.orimerc, codgrucli: obj.codgrucli }
      })
      //efetua a verificacao da duplicidade
      let duplicate = false
      for (var x = 0; x < arrRegra.length; x++) {
        this.$set(this.regraimpList[x], 'duplicate', false)
        test = arrRegra[x]
        if (test.ufdest != null && test.finalidade != null) {
          if (arrRegra.findIndex(obj => obj.ufdest == test.ufdest && obj.finalidade == test.finalidade &&
            obj.orimerc == test.orimerc && obj.codgrucli == test.codgrucli) < x) {
            this.regraimpList[x].duplicate = true
            this.regraimpList[x].validate = 'Duplicidade de regra'
            duplicate = true
          }
        }
      }
      return duplicate
    },

    async apiPost() {
      //efetua a inclusao das regras

      let modulo = 'cg/grutrib/'
      let sendData = {}
      let regraimpValid = this.configuraRegrasRegiao()

      sendData = { grutrib: this.grutrib }
      sendData.grutrib.regraimp = regraimpValid

      var metodo = 'post'

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)

      this.$erpToastSuccess('As regras foram gravadas com sucesso')
      this.$emit('save', data.items[0])
    },

  },

  created() {
    this.loadEstados()

    this.$scrollTo(0)

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
      this.$refs.ufdest.focus()
    })


  }

}

</script>

<style>
.nb-dica {
  position: relative;
  background: #267da5;
  padding: 8px;
  color: #fff;
  font-weight: 400;
  line-height: 18px;
  border-radius: 3px;
  height: 35px;
  z-index: 20;
  margin: -3px 0 0 15px;
  user-select: none;
  animation: tooltip_animation 2s linear infinite;
}

@keyframes tooltip_animation {

  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(-5px);
  }
}

.nb-dica:before {
  content: " ";
  width: 0;
  height: 0;
  position: absolute;
  left: -7px;
  top: 8px;
  border-color: transparent #267da5;
  border-style: solid;
  border-width: 8px 8px 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/forms/regraimp-add-form.vue